import { render } from "./TruthrPrivacy.vue?vue&type=template&id=88e1a9ca&scoped=true"
import script from "./TruthrPrivacy.vue?vue&type=script&lang=js"
export * from "./TruthrPrivacy.vue?vue&type=script&lang=js"

import "./TruthrPrivacy.vue?vue&type=style&index=0&id=88e1a9ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88e1a9ca"]])

export default __exports__